import SpeedFreaksItalicWOFF from "./Fonts/SpeedFreaks-Italic.woff"
import SpeedFreaksItalicWOFF2 from "./Fonts/SpeedFreaks-Italic.woff2"
import SpeedFreaksWOFF from "./Fonts/SpeedFreaks.woff"
import SpeedFreaksWOFF2 from "./Fonts/SpeedFreaks.woff2"
import SupremeLLItalicWOFF from "./Fonts/SupremeLL-Italic.woff"
import SupremeLLItalicWOFF2 from "./Fonts/SupremeLL-Italic.woff2"
import SupremeLLJumboWOFF from "./Fonts/SupremeLL-Jumbo.woff"
import SupremeLLJumboWOFF2 from "./Fonts/SupremeLL-Jumbo.woff2"
import SupremeLLJumboItalicWOFF from "./Fonts/SupremeLL-JumboItalic.woff"
import SupremeLLJumboItalicWOFF2 from "./Fonts/SupremeLL-JumboItalic.woff2"
import SupremeLLLightWOFF from "./Fonts/SupremeLL-Light.woff"
import SupremeLLLightWOFF2 from "./Fonts/SupremeLL-Light.woff2"
import SupremeLLLightItalicWOFF from "./Fonts/SupremeLL-LightItalic.woff"
import SupremeLLLightItalicWOFF2 from "./Fonts/SupremeLL-LightItalic.woff2"
import SupremeLLRegularWOFF from "./Fonts/SupremeLL-Regular.woff"
import SupremeLLRegularWOFF2 from "./Fonts/SupremeLL-Regular.woff2"

const FontsExport = {
    SpeedFreaksItalicWOFF,
    SpeedFreaksItalicWOFF2,
    SpeedFreaksWOFF,
    SpeedFreaksWOFF2,
    SupremeLLItalicWOFF,
    SupremeLLItalicWOFF2,
    SupremeLLJumboWOFF,
    SupremeLLJumboWOFF2,
    SupremeLLJumboItalicWOFF,
    SupremeLLJumboItalicWOFF2,
    SupremeLLLightWOFF,
    SupremeLLLightWOFF2,
    SupremeLLLightItalicWOFF,
    SupremeLLLightItalicWOFF2,
    SupremeLLRegularWOFF,
    SupremeLLRegularWOFF2
}

export default FontsExport